export const toRoomId = (roomPath: string) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return roomPath.split('/')[2]!;
};
